/*
**  rui-status-icon.js
**
**  rui-status-icon component
*/
import { LitElement, html } from 'lit-element';
export class RuiStatusIcon extends LitElement {
    static get is() {
        return 'rui-status-icon';
    }
    static get properties() {
        return {
            type: { type: String },
            iconType: { type: String },
            size: { type: String }
        };
    }
    constructor() {
        super();
        this.type = 'information';
        this.iconType = '';
        this.size = '16px';
    }
    render() {
        let statusType = this.type;
        if (!['information', 'success', 'warning', 'error', 'trend-up', 'trend-down'].includes(statusType)) {
            statusType = 'information';
        }
        let iconType = this.iconType.toLowerCase();
        let icon, iconContext;
        if (iconType === '') {
            if (statusType === 'error') {
                icon = 'error';
                iconContext = 'status-icon-error';
            }
            else if (statusType === 'warning') {
                icon = 'warning';
                iconContext = 'status-icon-warning';
            }
            else if (statusType === 'success') {
                icon = 'success';
                iconContext = 'status-icon-success';
            }
            else if (statusType === 'trend-up') {
                icon = 'next';
                iconContext = 'status-icon-trendup';
            }
            else if (statusType === 'trend-down') {
                icon = 'previous';
                iconContext = 'status-icon-trenddown';
            }
            else {
                icon = 'information';
                iconContext = 'status-icon-information';
            }
        }
        else {
            if (statusType === 'error') {
                icon = iconType;
                iconContext = 'status-icon-error';
            }
            else if (statusType === 'warning') {
                icon = iconType;
                iconContext = 'status-icon-warning';
            }
            else if (statusType === 'success') {
                icon = iconType;
                iconContext = 'status-icon-success';
            }
            else if (statusType === 'trend-up') {
                icon = iconType;
                iconContext = 'status-icon-trendup';
            }
            else if (statusType === 'trend-down') {
                icon = iconType;
                iconContext = 'status-icon-trenddown';
            }
            else {
                icon = iconType;
                iconContext = 'status-icon-information';
            }
        }
        return html `
            <rui-icon iconType="${icon}" context="${iconContext}" size="${this.size}" aria-hidden="true"></rui-icon>
        `;
    }
}
customElements.get(RuiStatusIcon.is) || customElements.define(RuiStatusIcon.is, RuiStatusIcon);
